<template>
  <div class="tabs tabbar" style="margin-bottom: 0;">
    <div class="columns is-mobile is-vcentered is-gapless has-text-weight-semibold"
      style="height:48px; margin-right: auto; margin-left: auto;">
      <router-link :to="{ path: '/explore' }"
        v-slot="{ href, navigate, isActive, isExactActive }" custom>
        <div class="column"
          @click="navigate"
          :class="[
                  isActive && 'router-link-active',
                  isExactActive && 'router-link-exact-active'
                  ]"
          >
          <a :href="href" @click="navigate" aria-label="Explore">
            <svg width="22px" height="22px">
              <use xlink:href="#explore-outline" class="outline" />
              <use xlink:href="#explore-fill" class="fill" />
            </svg>
          </a>
        </div>
      </router-link>
      <router-link :to="{ path: '/instruments' }"
        v-slot="{ href, navigate, isActive, isExactActive }" custom>
        <div class="column"
          @click="navigate"
          :class="[
                  isActive && 'router-link-active',
                  isExactActive && 'router-link-exact-active'
                  ]"
          >
          <a :href="href" @click="navigate" aria-label="Instruments">
            <svg width="22px" height="22px">
              <use xlink:href="#instruments-outline" class="outline" />
              <use xlink:href="#instruments-fill" class="fill" />
            </svg>
          </a>
        </div>
      </router-link>
      <router-link :to="{ path: '/genre' }"
        v-slot="{ href, navigate, isActive, isExactActive }" custom>
        <div class="column"
          @click="navigate"
          :class="[
                  isActive && 'router-link-active',
                  isExactActive && 'router-link-exact-active'
                  ]"
          >
          <a :href="href" @click="navigate" aria-label="Genre">
            <svg width="22px" height="22px">
              <use xlink:href="#genre-outline" class="outline" />
              <use xlink:href="#genre-fill" class="fill" />
            </svg>
          </a>
        </div>
      </router-link>
      <router-link :to="{ path: '/topics' }"
        v-slot="{ href, navigate, isActive, isExactActive }" custom>
        <div class="column"
          @click="navigate"
          :class="[
                  isActive && 'router-link-active',
                  isExactActive && 'router-link-exact-active'
                  ]"
          >
          <a :href="href" @click="navigate" aria-label="Topics">
            <svg width="22px" height="22px">
              <use xlink:href="#tags-outline" class="outline" />
              <use xlink:href="#tags-fill" class="fill" />
            </svg>
          </a>
        </div>
      </router-link>
      <router-link :to="{ path: '/signin' }" v-if="!user.loggedIn"
        v-slot="{ href, navigate, isActive, isExactActive }" custom>
        <div class="column"
          @click="navigate"
          :class="[
                  isActive && 'router-link-active',
                  isExactActive && 'router-link-exact-active'
                  ]"
          >
          <a :href="href" @click="navigate" aria-label="My Account">
            <svg width="22px" height="22px">
              <use xlink:href="#user-outline" class="outline" />
              <use xlink:href="#user-fill" class="fill" />
            </svg>
          </a>
        </div>
      </router-link>
      <router-link :to="'/user/' + user.data.uid" v-if="user.loggedIn"
        v-slot="{ href, navigate, isActive, isExactActive }" custom>
        <div class="column"
          @click="navigate"
          :class="[
                  isActive && 'router-link-active',
                  isExactActive && 'router-link-exact-active'
                  ]"
          >
          <a :href="href" @click="navigate">
            <svg width="22px" height="22px">
              <use xlink:href="#user-outline" class="outline" />
              <use xlink:href="#user-fill" class="fill" />
            </svg>
          </a>
        </div>
      </router-link>
    </div>

    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
      <symbol id="explore-outline" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.611 1a9.611 9.611 0 1 1 0 19.222 9.611 9.611 0 0 1 0-19.222zm3.34 6.27L8.864 8.863 7.27 13.952l5.09-1.593 1.592-5.089z" stroke="#130F26" stroke-width="1.8" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/>
      </symbol>
      <symbol id="explore-fill" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.611.1c5.805 0 10.511 4.706 10.511 10.511 0 5.805-4.706 10.511-10.511 10.511C4.806 21.122.1 16.416.1 10.611.1 4.806 4.806.1 10.611.1zm4.2 7.439a.9.9 0 0 0-1.128-1.128l-5.09 1.593a.9.9 0 0 0-.59.59l-1.592 5.09A.9.9 0 0 0 7.54 14.81l5.09-1.593a.9.9 0 0 0 .59-.59z" fill="#000" fill-rule="evenodd"/>
      </symbol>

      <symbol id="instruments-outline" viewBox="0 0 22 19" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.025 0A3.038 3.038 0 0 0 0 3.025V15.95a3.038 3.038 0 0 0 3.025 3.025h15.95A3.038 3.038 0 0 0 22 15.95V3.025A3.038 3.038 0 0 0 18.975 0H3.025zm0 1.65h15.95c.769 0 1.375.606 1.375 1.375V9.9h-2.34a.825.825 0 0 0-.268 0H15.26a.825.825 0 0 0-.268 0H9.76a.825.825 0 0 0-.268 0H7.01a.825.825 0 0 0-.268 0H4.26a.825.825 0 0 0-.268 0H1.65V3.025c0-.769.606-1.375 1.375-1.375zm-1.375 9.9H3.3v3.575a.825.825 0 1 0 1.65 0V11.55h1.1v3.575a.825.825 0 1 0 1.65 0V11.55h1.1v3.575a.825.825 0 1 0 1.65 0V11.55h3.85v3.575a.825.825 0 1 0 1.65 0V11.55h1.1v3.575a.825.825 0 1 0 1.65 0V11.55h1.65v4.4c0 .769-.606 1.375-1.375 1.375H3.025A1.363 1.363 0 0 1 1.65 15.95v-4.4z" fill="#000" fill-rule="nonzero"/>
      </symbol>
      <symbol id="instruments-fill" viewBox="0 0 22 19" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.025 0A3.028 3.028 0 0 0 0 3.025V15.95a3.028 3.028 0 0 0 3.025 3.025h15.95A3.028 3.028 0 0 0 22 15.95V3.025A3.028 3.028 0 0 0 18.975 0H3.025zM1.65 11.55H3.3v3.575a.825.825 0 1 0 1.65 0V11.55h1.1v3.575a.825.825 0 1 0 1.65 0V11.55h1.1v3.575a.825.825 0 1 0 1.65 0V11.55h3.85v3.575a.825.825 0 1 0 1.65 0V11.55h1.1v3.575a.825.825 0 1 0 1.65 0V11.55h1.65v4.4c0 .758-.617 1.375-1.375 1.375H3.025A1.377 1.377 0 0 1 1.65 15.95v-4.4z" fill="#000" fill-rule="nonzero"/>
      </symbol>

      <symbol id="genre-outline" viewBox="0 0 22 21" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.342 0a.869.869 0 1 0 0 1.737h13.316a.869.869 0 1 0 0-1.737H4.342zM2.605 2.895a.869.869 0 1 0 0 1.737h16.79a.869.869 0 1 0 0-1.737H2.605zm-.579 2.894A2.04 2.04 0 0 0 0 7.816v11a2.04 2.04 0 0 0 2.026 2.026h17.948A2.04 2.04 0 0 0 22 18.816v-11a2.04 2.04 0 0 0-2.026-2.027H2.026zm0 1.737h17.948c.17 0 .29.119.29.29v11c0 .17-.12.29-.29.29H2.026a.277.277 0 0 1-.29-.29v-11c0-.171.12-.29.29-.29zM11 9.263c-.007 0-.012.004-.02.005a.576.576 0 0 0-.194.038c-.011.005-.02.012-.033.017-.026.013-.053.023-.078.04-.024.016-.044.037-.065.056-.009.008-.018.015-.026.024a.58.58 0 0 0-.108.16l-.015.038a.587.587 0 0 0-.04.201v4.287a2.938 2.938 0 0 0-1.158-.234c-1.298 0-2.316.763-2.316 1.737 0 .973 1.018 1.736 2.316 1.736 1.299 0 2.316-.763 2.316-1.736v-3.198l2.1.84a.57.57 0 0 0 .54-.058.58.58 0 0 0 .255-.48v-.952c0-.715-.43-1.347-1.093-1.613l-2.166-.867a.586.586 0 0 0-.194-.036c-.007 0-.013-.005-.021-.005z" fill="#000" fill-rule="nonzero"/>
      </symbol>
      <symbol id="genre-fill" viewBox="0 0 22 21" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.342 0a.869.869 0 1 0 0 1.737h13.316a.869.869 0 1 0 0-1.737H4.342zM2.605 2.895a.869.869 0 1 0 0 1.737h16.79a.869.869 0 1 0 0-1.737H2.605zm-.579 2.894A2.029 2.029 0 0 0 0 7.816v11c0 1.117.909 2.026 2.026 2.026h17.948A2.029 2.029 0 0 0 22 18.816v-11a2.029 2.029 0 0 0-2.026-2.027H2.026zM11 9.263c.008 0 .015.005.023.005a.58.58 0 0 1 .192.036l.01.004 2.885 1.154a.58.58 0 0 1 .364.538v1.737a.58.58 0 0 1-.794.538l-2.101-.841v3.198c0 .973-1.017 1.736-2.316 1.736-1.298 0-2.316-.763-2.316-1.736 0-.974 1.018-1.737 2.316-1.737.427 0 .818.088 1.158.234V9.842c0-.07.017-.137.04-.201l.015-.039a.568.568 0 0 1 .108-.16c.009-.008.018-.014.027-.023.02-.019.04-.04.064-.056.025-.017.051-.027.077-.039.012-.006.023-.013.035-.018a.577.577 0 0 1 .193-.038c.007 0 .012-.005.02-.005z" fill="#000" fill-rule="nonzero"/>
      </symbol>

      <symbol id="tags-outline" viewBox="0 0 20 22" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.2 4.14l-4-2.44-.01-.01a2.71 2.71 0 0 0-1.92-.37h0c-.62-.33-1.33-.41-2-.24L5.74 2.33h-.01c-.95.25-1.68.99-1.94 1.93L.55 15.46H.54c-.45 1.49.41 3.07 1.91 3.51h.01l4.31 1.19-.01-.01c.51.5 1.21.79 1.93.8h8-.01a2.821 2.821 0 0 0 2.8-2.8V6.48l-.01-.01c-.01-.98-.53-1.89-1.37-2.39l.1.06zM2.92 17.52l-.01-.01c-.71-.2-1.12-.92-.92-1.62l3.26-11.2h-.01c.11-.45.46-.79.9-.91l3.07-.79-1.94 1.14v-.01c-.82.51-1.31 1.42-1.3 2.38v11.67-.01c-.01.06-.01.12-.01.19l-3.04-.83zM18 18.2h0c0 .71-.59 1.3-1.3 1.3H8.69c-.39 0-.76-.17-1-.47l-.01-.01c-.21-.24-.32-.54-.31-.84V6.51l-.01-.01c-.01-.46.23-.88.62-1.11l3.98-2.42h-.01c.1-.07.22-.12.33-.15v-.01c.11-.04.24-.06.37-.05h-.01c.24-.01.47.06.67.18l4 2.45h0c.37.23.6.64.61 1.08L18 18.2z" fill="#000" fill-rule="nonzero" stroke="#000" stroke-width=".2"/>
      </symbol>
      <symbol id="tags-fill" viewBox="0 0 20 22" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.2 4.14l-4-2.44-.01-.01a2.71 2.71 0 0 0-1.92-.37h0c-.62-.33-1.33-.41-2-.24L5.74 2.33h-.01c-.95.25-1.68.99-1.94 1.93L.55 15.46H.54c-.45 1.49.41 3.07 1.91 3.51h.01l4.31 1.19-.01-.01c.51.5 1.21.79 1.93.8h8-.01a2.821 2.821 0 0 0 2.8-2.8V6.48l-.01-.01c-.01-.98-.53-1.89-1.37-2.39l.1.06zM2.92 17.52l-.01-.01c-.71-.2-1.12-.92-.92-1.62l3.26-11.2h-.01c.11-.45.46-.79.9-.91l3.07-.79-1.94 1.14v-.01c-.82.51-1.31 1.42-1.3 2.38v11.67-.01c-.01.06-.01.12-.01.19l-3.04-.83z" fill="#000" fill-rule="nonzero" stroke="#000" stroke-width=".2"/>
      </symbol>

      <symbol id="user-outline" viewBox="-2 -1 20 21" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 12.13c1.91 0 3.772.474 5.304 1.356 1.569.903 2.714 2.188 3.243 3.668a.87.87 0 1 1-1.639.586c-.383-1.071-1.246-2.04-2.472-2.746-1.262-.726-2.824-1.124-4.436-1.124s-3.174.398-4.436 1.124c-1.226.705-2.09 1.675-2.472 2.746a.87.87 0 1 1-1.639-.586c.53-1.48 1.674-2.766 3.243-3.668C5.228 12.604 7.09 12.13 9 12.13zm0-12a4.87 4.87 0 1 1 0 9.74A4.87 4.87 0 0 1 9 .13zm0 1.74a3.13 3.13 0 1 0 0 6.26 3.13 3.13 0 0 0 0-6.26z" fill="#000" fill-rule="nonzero"/>
      </symbol>
      <symbol id="user-fill" viewBox="-2 -1 20 21" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 12.13c1.91 0 3.772.474 5.304 1.356 1.569.903 2.714 2.188 3.243 3.668a.87.87 0 1 1-1.639.586c-.383-1.071-1.246-2.04-2.472-2.746-1.262-.726-2.824-1.124-4.436-1.124s-3.174.398-4.436 1.124c-1.226.705-2.09 1.675-2.472 2.746a.87.87 0 1 1-1.639-.586c.53-1.48 1.674-2.766 3.243-3.668C5.228 12.604 7.09 12.13 9 12.13zm0-12a4.87 4.87 0 1 1 0 9.74A4.87 4.87 0 0 1 9 .13z" fill="#000" fill-rule="nonzero"/>
      </symbol>
    </svg>
    <!-- eslint-enable -->

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import firebase from 'firebase/app';
import 'firebase/auth';

export default {
  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },

  methods: {
    logout() {
      firebase.auth().signOut().then(() => {
        localStorage.removeItem('accessToken');

        if (this.$route.name !== 'Home') {
          this.$router.replace({ name: 'Home' });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tabbar .router-link-exact-active {
  border-bottom: none;
}
.tabs.tabbar .router-link-exact-active a {
  color: #000;
}

.fill {
  display: none;
}
.tabbar .router-link-exact-active .fill {
  display: block;
}
.tabbar .router-link-exact-active .outline {
  display: none;
}

.tabs.tabbar a {
  padding:0px 20px;
  border-bottom: none;
}
</style>
